import React from "react";
import PropTypes from "prop-types";
import { Flex, Heading, Label } from "@badi/badi-components";
import PremiumLabel from "modules/premium/label";
import { translate } from "base/shared/Localization";

const Title = ({ premium = false }) => (
  <Flex alignItems="center" gutter={2}>
    <Heading data-qa="enquiry-title" level="28-Extrabold">
      {translate("lister.contact.request_title")}
    </Heading>
    {premium ? (
      <PremiumLabel />
    ) : (
      <Label dataQa="enquiry-label" size="small" variant="temporary">
        {translate("free.plan_banner")}
      </Label>
    )}
  </Flex>
);

Title.propTypes = {
  premium: PropTypes.bool,
};

export default Title;
